/**
 * Contract-editor widths. The Shell gives editor routes the full main
 * column; the page centres its header, status bar, tab strip and most tabs
 * at the chrome width, while the Avtal tab (form + A4 preview side by side)
 * may grow slightly wider on large monitors. Below ~1690px viewport both resolve to
 * the available column, so laptops are unchanged.
 */
export const EDITOR_CHROME_WIDTH = 'mx-auto w-full max-w-[1400px]';
export const EDITOR_AVTAL_WIDTH = 'mx-auto w-full max-w-[1560px]';
